import { motion } from 'framer-motion'
import { easing, duration } from '@/lib/animations'

const transition = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: duration.normal, ease: easing.outQuad }
}

function PageTransition({ children, motionKey }) {
  return (
    <motion.div
      key={motionKey}
      className="w-full"
      initial={transition.initial}
      animate={transition.animate}
      exit={transition.exit}
      transition={transition.transition}
    >
      {children}
    </motion.div>
  )
}

export default PageTransition
